import axios from "axios";

export async function patchTrialCreditsEarned(idConteudoPolopoly, idSessao) {
  return await axios
    .put(`/paywall/creditos-degustador`, null, {
      params: {
        idSessao,
        idConteudoPolopoly,
      },
    })
    .then((res) => {
      return res;
    })
    .catch((e) => {
      return { status: false, erro: e };
    });
}
